/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.37.0
 * @since 1.37.0
 */

import styled from 'styled-components';

import { fonts } from '@/main/theme';
import { RadioButtonContainerStyled } from '@components/common/RadioButton/styled/RadioButtonStyled';

export const WizardChangeRoleStyled = styled.div.attrs({
    className: 'wizard-change-role',
})`
    display: grid;
    grid-template-columns: 1fr 1fr;

    .wizard-change-role__title {
        margin-top: 20px;
        ${fonts.textHeader3}
    }

    .wizard-change-role__radio-button {
        margin-top: 32px;
    }

    ${RadioButtonContainerStyled} {
        > input + label {
            pointer-events: none;
        }
    }
`;


